type OrganizationLike = {
  name?: string | null;
  companyDescription?: string | null;
};

type DeviceLike = {
  name?: string | null;
  description?: string | null;
};

export const SYSTEM_DATA_KEYS = {
  "company-name": { scope: "organization" },
  "company-description": { scope: "organization" },
  "device-name": { scope: "device" },
  "device-description": { scope: "device" },
} as const;

export type SystemDataKeyId = keyof typeof SYSTEM_DATA_KEYS;

export const isSystemDataKey = (
  dataKeyId?: string
): dataKeyId is SystemDataKeyId =>
  !!dataKeyId && dataKeyId in SYSTEM_DATA_KEYS;

export const isOrganizationSystemDataKey = (
  dataKeyId?: string
): dataKeyId is Extract<SystemDataKeyId, "company-name" | "company-description"> =>
  isSystemDataKey(dataKeyId) && SYSTEM_DATA_KEYS[dataKeyId].scope === "organization";

export const isDeviceSystemDataKey = (
  dataKeyId?: string
): dataKeyId is Extract<SystemDataKeyId, "device-name" | "device-description"> =>
  isSystemDataKey(dataKeyId) && SYSTEM_DATA_KEYS[dataKeyId].scope === "device";

export const getSystemDataKeyValue = ({
  dataKeyId,
  organization,
  device,
}: {
  dataKeyId?: string;
  organization?: OrganizationLike;
  device?: DeviceLike;
}) => {
  switch (dataKeyId) {
    case "company-name":
      return organization?.name ?? "";
    case "company-description":
      return organization?.companyDescription ?? "";
    case "device-name":
      return device?.name ?? "";
    case "device-description":
      return device?.description ?? "";
    default:
      return "";
  }
};

export const getOrganizationSystemDataKeyPayload = ({
  dataKeyId,
  value,
}: {
  dataKeyId: Extract<SystemDataKeyId, "company-name" | "company-description">;
  value: string;
}) => {
  switch (dataKeyId) {
    case "company-name":
      return { name: value.trim() };
    case "company-description":
      return { companyDescription: value.trim() || null };
  }
};

export const getDeviceSystemDataKeyPayload = ({
  dataKeyId,
  value,
}: {
  dataKeyId: Extract<SystemDataKeyId, "device-name" | "device-description">;
  value: string;
}) => {
  switch (dataKeyId) {
    case "device-name":
      return { name: value };
    case "device-description":
      return { description: value };
  }
};
